exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n.row-beat-container[data-v-e99ecde0]:last-of-type {\n  border-bottom: none;\n}\n\n/* purgecss end ignore */\n", ""]);
